/*
  * Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
  * SPDX-License-Identifier: MIT
  *
  * Licensed under the MIT License. See the LICENSE accompanying this file
  * for the specific language governing permissions and limitations under
  * the License.
  */

import React from 'react';
import { connect } from 'react-redux';
import { setLang, setAuth } from '../../redux/actions';

import { I18n } from '@aws-amplify/core';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import brandLogo from '../../assets/Logos/brand-logo.png';
import LanguageSelect from '../LanguageSelect/LanguageSelect';

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		marginBottom: theme.spacing(6),
	},
	header: {
    display: 'flex',
		justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(3, 10),
  },
  logo: {
		width: '90px',
  },
	actionBox: {
		display: 'flex',
		alignItems: 'center',
		gap: '20px',
	},
	logoutText: {
		fontFamily: 'AkkoPro Medium',
		color: '#00547A',
		textDecoration: 'none',
		textUnderlineOffset: '3px',
		'&:hover': {
			cursor: 'pointer',
			textDecoration: 'underline',
		},
	},
}));

const mapStateToProps = (state) => {
	return {
		lang: state.app.lang,
		auth: state.app.auth,
	}
}

const Header = (props) => {
	const classes = useStyles();
	const [anchorEl, setAnchorEl] = React.useState(null);

	const handleRouteTo = (routeTo) => {
		setAnchorEl(null);
		if (routeTo) props.routeTo(routeTo);
	};

	return (
		<div className={classes.root}>
			<div className={classes.header}>
				<img src={brandLogo} className={classes.logo}/>
				<div className={classes.actionBox}>
					<LanguageSelect />
					<Typography className={classes.logoutText} onClick={() => handleRouteTo('/logout')}>
						{I18n.get("HEADER_MENU_ITEM_LOGOUT")}
					</Typography>
				</div>
			</div>
		</div>
	);
}

export default connect(mapStateToProps, { setLang, setAuth })(Header)
